import api from "../../../../util/api";
import {SUCCESS, ERROR, LOADING} from "../../../mutation-types";
import { getField, updateField } from 'vuex-map-fields';
import { Formula, createFormula } from "../../../../models/Formula";
import { commonMutations, commonState } from "../../../common";
import DataWrapper from "../../../../util/DataWrapper";

let state = ()=> ({
    ...commonState(),
    formula:new Formula()
});

// getters
let getters = {
    getField
};

// actions
let actions = {
    async save({ dispatch, commit, state, rootGetters }, reset=false){
        if(!state.formula.id) {
            try {
                commit(LOADING, true);
                let formula = await api.formulas.create(createFormula(state.formula), rootGetters['account/token'], rootGetters['account/companyId']);
                commit('formulas/push', formula, {root: true});
                commit('edit', formula);
                if(reset)
                    commit("reset")
                commit(SUCCESS);
            } catch (error) {
                commit(ERROR, error);
            }
        }else{
            await dispatch('update', reset);
        }
    },
    async update({ commit, rootGetters, state }, reset=false){
        try{
            commit(LOADING, true);
            state.formula = await api.formulas.edit(createFormula(state.formula), rootGetters['account/token'], rootGetters['account/companyId']);
            commit('formulas/replace', state.formula, { root: true });
            if(reset)
                commit("reset")
            commit(SUCCESS);
        } catch (error) {
            console.log(error)
            commit(ERROR, error);
        }
    },
    async delete({ commit, state, rootGetters }){
        try{
            commit(LOADING, true);
            let success =  await api.formulas.delete(createFormula(state.formula), rootGetters['account/token'], rootGetters['account/companyId']);
            if(success) {
                commit('formulas/delete', createFormula(state.formula), {root: true});
                commit(SUCCESS);
            }else{
                commit(ERROR, "Error deleting formula");
            }
        }catch(error){
            commit(ERROR, error);
        }
    },
    async edit({ commit, rootGetters }, id){
        try{
            commit(LOADING, true);
            let formula = await api.formulas.find(id, rootGetters['account/token'], rootGetters['account/companyId'])
            commit('edit', formula);
            commit(SUCCESS);
        } catch (error) {
            commit(ERROR, error.message);
        }
    }
};

// mutations
let mutations = {
    updateField,
    ...commonMutations,
    edit:(state, formula)=>{
        state.formula = new Formula(formula);
    },
    reset:(state)=>{
        state.formula = new Formula();
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};